import React from 'react'
import NumberFormat from 'react-number-format'
import { Link } from 'react-router-dom';

import { line, curveMonotoneX } from 'd3-shape'

export const sankeyLinkHorizontal = () => {
  const lineGenerator = line().curve(curveMonotoneX)
  return (link, contract = 1, reorganizeGraph, columnWidth ) => {
    const thickness = Math.max(1, link.width - contract * 2)
    const halfThickness = thickness / 2
    const targetX0 = reorganizeGraph && link.target.page === 0 ? link.target.x0 + columnWidth : link.target.x0
    const linkLength = targetX0 - link.source.x1
    const padLength = linkLength * 0.12

    const dots = [
      [link.source.x1, link.y0 - halfThickness],
      [link.source.x1 + padLength, link.y0 - halfThickness],
      [targetX0 - padLength, link.y1 - halfThickness],
      [targetX0, link.y1 - halfThickness],
      [targetX0, link.y1 + halfThickness],
      [targetX0 - padLength, link.y1 + halfThickness],
      [link.source.x1 + padLength, link.y0 + halfThickness],
      [link.source.x1, link.y0 + halfThickness],
      [link.source.x1, link.y0 - halfThickness],
    ]

    return lineGenerator(dots) + 'Z'
  }
}

export function truncate(string, width) {
  if (Math.floor(string.length * 5.47) >= width) return string.substring(0, Math.floor(width / 5.47)) + '...';
  else return string;
}

export function getOpacity(element, currentActives, opacities) {
  const id = element.id ? element.id : `${element.source.id}${element.target.id}`;
  if (element.id) {
    return currentActives.includes(id) || currentActives.length === 0 ? opacities.nodeOpacity : opacities.nodeHoverOthersOpacity;
  } else {
    return currentActives.includes(id) || currentActives.length === 0 ? opacities.linkOpacity : opacities.linkHoverOthersOpacity;
  }
}

export function calculeTooltipPosition(offsetX, offsetY, sankeyWidth, sankeyHeight, tooltipWidth, tooltipHeight) {
  const position = {
    left: offsetX + 20,
    top: offsetY + 10,
    tooltipWidth,
    tooltipHeight,
  }

  if (!(position.left < position.tooltipWidth) && (position.left + position.tooltipWidth) > sankeyWidth) position.left = (position.left - position.tooltipWidth) - 40;
  if ((position.top + position.tooltipHeight) > sankeyHeight) position.top = (position.top - position.tooltipHeight) - 20;


  return {
    left: position.left,
    top: position.top,
  }
}

export const percent = cell => {
  if (cell === null) return 'N/A'

  return <NumberFormat
    value={cell * 100}
    displayType="text"
    decimalSeparator="."
    suffix={'%'}
    decimalScale={0}
    fixedDecimalScale={true}
  />
}

export const numberFormat = (cell, percent) => {
  if (percent && typeof percent === 'number') {
    return <span>
      <NumberFormat value={cell} displayType="text" thousandSeparator={true} /> - {percent}%
    </span>
  }

  return <NumberFormat value={cell} displayType="text" thousandSeparator={true} />
}

export const formatPath = row => <Link
  to={`/path/paths/${row.value}`}
  className='truncate w-40 twy-text-accent hover:underline'
>
  #{row.value} - {row.name}
</Link>

